import {
    AutocompleteInput,
    DateInput,
    NumberInput,
    ReferenceInput,
    SelectInput,
    SimpleForm,
    TextInput,
} from "react-admin";
import {FormProps} from "../../shared/types";
import {initInput} from "../../shared/utils";
import {Grid} from "@material-ui/core";
import {ReferenceInputBank} from "../../components/reference-inputs/ReferenceInputBank";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";
import {CustomToolbar} from "../../components/CustomToolbar";

export const JournalEntryForm = (props: FormProps) => {

    return (
        <SimpleForm
            {...props}
            toolbar={
                <CustomToolbar canEdit={props.canEdit} canDelete={props.canDelete}/>
            }
        >
            <Grid spacing={2} container alignItems="center" style={{width: "100%"}}>
                <Grid item xs={6}>
                    <TextInput {...initInput("description", props.fieldOptions, props.canEdit)} />
                </Grid>
                <Grid item xs={6}>
                    <NumberInput {...initInput("amount", props.fieldOptions, props.canEdit)} />
                </Grid>
                <Grid item xs={6}>
                    <DateInput {...initInput("date", props.fieldOptions, props.canEdit)} />
                </Grid>
                <Grid item xs={6}>
                    <SelectInput
                        {...initInput("journal_type", props.fieldOptions, props.canEdit,
                            "array")}
                        choices={props.fieldOptions.journal_type.choices
                        }
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextInput {...initInput("document_number", props.fieldOptions, props.canEdit)} />
                </Grid>
                <Grid item xs={6}>
                    <TextInput {...initInput("notes", props.fieldOptions, props.canEdit)} />
                </Grid>
                <Grid item xs={6}>
                    <ReferenceInputBank {...initInput("bank", props.fieldOptions, props.canEdit)} />
                </Grid>
                <Grid item xs={6}>
                    <ReferenceInputSubject {...initInput("subject_id", props.fieldOptions, props.canEdit)} />
                </Grid>
                <Grid item xs={6}>
                    <SelectInput
                        {...initInput("payment_method", props.fieldOptions, props.canEdit,
                            "array")}
                        choices={props.fieldOptions.payment_method.choices
                        }
                    />
                </Grid>
                <Grid item xs={6}>
                    <ReferenceInput
                        {...initInput("journal_category", props.fieldOptions, props.canEdit)}
                        source="journal_category" reference="autocomplete/journal-category">
                        <AutocompleteInput optionText="label" />
                    </ReferenceInput>
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
